<template>
	<HeroLayout>
		<div class="flex flex-col w-full h-full">
			<img class="registration-title-image" :src="logoPath" alt="Logo" />
			<p class="registration-title">Reset password</p>
			<p class="registration-subtitle mt-1 mb-10">Reset password for {{ maskedEmail() }}</p>
			<form>
				<div class="flex relative mb-4">
					<InputText label="New password*" :type="hidePassword ? 'password' : 'text'" autocomplete="new-password" class="w-full userpilot-mask"
								  placeholder="Enter a new password" v-model="password" icon="password" :errors="error" error-field="user.password" />
					<p class="registration-password-toggle" v-if="hidePassword" @click.prevent="hidePassword = false">Show password</p>
					<p class="registration-password-toggle" v-if="!hidePassword" @click.prevent="hidePassword = true">Hide password</p>
				</div>

				<InputText label="Confirm password*" :type="hidePassword ? 'password' : 'text'" class="userpilot-mask" autocomplete="new-password"
							  placeholder="Re-enter new password" v-model="passwordConfirmation" icon="password"
							  :errors="error" error-field="user.password_confirmation" />

				<SubmitButton class="ml-auto mt-10" label="Reset Password" :loading="isLoading" @click="resetForgottenPassword" />
				<ValidationError :errors="error" :field="null" />

				<p class="text-grayscale-body text-end mt-3">Don't need to reset your password?
					<router-link :to="{ name: 'auth.login' }" class="clickable-text">Log in</router-link>
					.
				</p>
			</form>
		</div>
	</HeroLayout>
</template>

<script setup lang="js">
import { onMounted, ref } from 'vue'
import InputText from '@/components/Forms/InputText.vue'
import { useAuthStore } from '@/stores/authStore.js'
import ValidationError from '@/components/Forms/InputError.vue'
import { useRoute } from 'vue-router'
import HeroLayout from '@/layouts/HeroLayout.vue'
import router from '@/router/router.js'
import SubmitButton from '@/components/Forms/Buttons/SubmitButton.vue'
import { userApi } from '@/api/User/UserApi.js'
import { Tenants } from '@/models/tenants/Tenants.js'

const route = useRoute()
const hidePassword = ref(true)
const isLoading = ref(false)
const error = ref(null)
const authStore = useAuthStore()
const password = ref('')
const passwordConfirmation = ref('')
const logoPath = ref('')

onMounted(() => {
	const tenant = Tenants.getTenant()
	logoPath.value = new URL(`../../assets/images/theme/${tenant.registrationLogo.image}`, import.meta.url).href
})

function maskedEmail()
{
	return route.query.email ? route.query.email.replace(/^(.)(.*)(.@.*)$/,
		(_, a, b, c) => a + b.replace(/./g, '*') + c
	) : ''
}

function resetForgottenPassword()
{
	const token = (route.query.token ?? '')
	const email = (route.query.email ?? '')

	isLoading.value = true
	error.value = null

	userApi.resetPassword({
		'user': {
			'token': token,
			'email': email,
			'password': password.value,
			'password_confirmation': passwordConfirmation.value
		}
	}, (response) => {
		isLoading.value = false
		if (authStore.handleLoginResult(response.body(), email, password.value))
		{
			authStore.userpilotIdentify()
			router.push({ name: 'dashboard' })
		}
	}, (e) => {
		error.value = e.showErrorBanner()
		isLoading.value = false
	})
}
</script>
